import apiEndPoints from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

// const getRolewiseProjectReport = async (params) => {
//     const data = await apiCall(
//       "post",
//       apiEndPoints.ROLEWISEPROJECTREPORT,
//       params
//     );
//     return data;
//   };

const getProjectDetailsReports = async (params) => {
  const data = await apiCall("post", apiEndPoints.PROJECTDETAILSREPORT, params);
  return data;
};

const getDepostionReport = async (params) => {
  // Add isLoadMore flag to disable global loader for this report
  const data = await apiCall(
    "post",
    apiEndPoints.DEPOSITIONREPORT,
    // params
    { ...params, isLoadMore: true }
  );
  return data;
};

const getAllChanelPartnerData = async (params) => {
  const data = await apiCall("post", apiEndPoints.CHANELPARTNERREPORT, params);
  return data;
};

const WebReportService = {
  // getRolewiseProjectReport,
  getProjectDetailsReports,
  getDepostionReport,
  getAllChanelPartnerData,
};

export default WebReportService;
